import { authLoader, verificationLoader, verifiedIdLoader, verifyIdLoader } from '@/navigation/loaders/authLoader';
import { lazyRoute } from '@/navigation/utils/lazyRoute';
import StripeOnboardingReturn from '@common/vendor/StripeOnboardingReturn';

/**
 * Protected routes - require authentication.
 * Uses RootLayout (Header + Footer), not dashboard sidebar.
 */
export const protectedRoutes = [
  // ID Verification (accessible even if not verified)
  {
    path: 'verifyid',
    loader: verifyIdLoader,
    lazy: lazyRoute(() => import('@/component/auth/verify-id')),
  },
  // After checkout, which takes a verified ID: a check Stripe is still
  // reviewing gets into the app but not through checkout (Tyler, 2026-10-22).
  {
    path: 'success',
    loader: verifiedIdLoader,
    lazy: lazyRoute(() => import('@/component/pages/success')),
  },
  // Misc protected pages
    // Stripe onboarding redirects — vendor returns here after Stripe's hosted flow.
  // StripeOnboardingReturn invalidates cached account data before redirecting.
  {
    path: 'vendor/onboarding/return',
    loader: authLoader,
    element: <StripeOnboardingReturn />,
  },
  {
    path: 'vendor/onboarding/refresh',
    loader: authLoader,
    element: <StripeOnboardingReturn />,
  },
];

/**
 * Header-only routes - require authentication, no footer.
 * Uses HeaderOnlyLayout (Header only, no Footer).
 */
export const headerOnlyRoutes = [
  {
    path: 'cart',
    loader: verificationLoader,
    lazy: lazyRoute(() => import('@/component/pages/cart')),
  },
  {
    // Shared-cart preview. Signed-in and past the app's ID gate like the cart
    // page, by decision (Tyler, 2026-09-21; the gate lets in a check Stripe
    // is still reviewing since 2026-10-22): the preview exists to be imported into
    // the viewer's own cart, which takes an account, and showing someone
    // else's cart to a guest is a security question of its own. A logged-out
    // hit is bounced through login with ?returnTo= and lands back here. The
    // :token is the authorization to read that cart.
    path: 'cart/shared/:token',
    loader: verificationLoader,
    lazy: lazyRoute(() => import('@/component/pages/cart/shared')),
  },
  // Checkout takes a verified ID: a check Stripe is still reviewing waits
  // for the verdict (Tyler, 2026-10-22).
  {
    path: 'checkout',
    loader: verifiedIdLoader,
    lazy: lazyRoute(() => import('@/component/pages/cart/checkout')),
  },
];
